import { get } from '../apiService';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';

export interface SickVisitSlot {
  providerId: string;
  practiceId: string;
  practiceName: string;
  firstName: string;
  lastName: string;
  today_slots: Array<{
    physicianId: string;
    facilityId: string;
    startTime: string;
    duration: string;
    slotId: string;
    type: string;
    priority: number;
  }>;
  tomorrow_slots: Array<{
    physicianId: string;
    facilityId: string;
    startTime: string;
    duration: string;
    slotId: string;
    type: string;
    priority: number;
  }>;
  day_after_tomorrow_slots: Array<{
    physicianId: string;
    facilityId: string;
    startTime: string;
    duration: string;
    slotId: string;
    type: string;
    priority: number;
  }>;
}

export interface GetSickVisitsResponse {
  status: string;
  providerSlots: SickVisitSlot[];
}

/**
 * Fetches sick visit slots for a given market.
 * @param marketId The market ID
 * @returns { data: GetSickVisitsResponse | null, loading: boolean, error: unknown }
 */
export const getSickVisits = async (
  marketId: string
): Promise<{ data: GetSickVisitsResponse | null; loading: boolean; error: unknown }> => {
  let loading = true;
  let data: GetSickVisitsResponse | null = null;
  let error: unknown = null;

  try {
    const customerId = getCustomerIdFromToken();
    if (!customerId) {
      throw new Error('Customer Id is not available');
    }
    const url = `/resourceMatrix/market/get_slots_by_market_id?customerId=${encodeURIComponent(
      customerId
    )}&marketId=${encodeURIComponent(marketId)}`;
    data = await get<GetSickVisitsResponse>(url);
  } catch (err) {
    error = err;
    data = null;
  } finally {
    loading = false;
  }

  return { data, loading, error };
};